<template>
  <div class="group-management">
    <template v-if="hasData">
      <template v-if="Array.isArray(treeData)">
        <GroupNode
          v-for="node in treeData"
          :key="node.entity.external_id"
          variant="array-item"
          :node="node"
          :current-entity-id="currentEntityId"
          @onSuccess="emit('onSuccess')"
        />
      </template>

      <template v-else>
        <GroupNode
          variant="solo"
          :node="treeData"
          :current-entity-id="currentEntityId"
          @onSuccess="emit('onSuccess')"
        />
      </template>
    </template>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import GroupNode from './GroupNode.vue';

const emit = defineEmits(['onSuccess']);

const props = defineProps({
  treeData: {
    type: [Array, Object],
    default: () => null,
  },
  currentEntityId: {
    type: [String, Number],
    default: null,
  },
});

const hasData = computed(() => props.treeData && (
  (Array.isArray(props.treeData) && props.treeData.length > 0) ||
        (props.treeData.entity && props.treeData.descendants)
));
</script>

<style scoped>
.group-management {
  background-color: var(--stk-background);
  border: 1px solid var(--stk-border);
  border-radius: 1em;
  padding: 1em;
}
</style>
